<template>
  <div class="container my-4">
    <h1>{{ $t("Cookies.title") }}</h1>
    <p>{{ $t("Cookies.intro") }}</p>

    <h2>{{ $t("Cookies.h2.what") }}</h2>
    <p>{{ $t("Cookies.what") }}</p>

    <h2>{{ $t("Cookies.h2.purpose") }}</h2>
    <p>{{ $t("Cookies.purpose") }}</p>

    <h2>{{ $t("Cookies.h2.firstAndThird") }}</h2>
    <p>{{ $t("Cookies.firstAndThird") }}</p>

    <h2>{{ $t("Cookies.h2.whichCookies") }}</h2>
    <p>{{ $t("Cookies.whichCookies") }}</p>

    <h2>{{ $t("Cookies.h2.consent") }}</h2>
    <p>{{ $t("Cookies.consent") }}</p>
  </div>
</template>

<script>
export default {
  name: "CookiesPage",
};
</script>

<style scoped>
.container {
  max-width: 900px;
}
h1 {
  margin-bottom: 1rem;
}
h2 {
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
}
p {
  margin-bottom: 0.75rem;
}
</style>
